import { render } from "./TestComponent.vue?vue&type=template&id=54c2bb2e"
import script from "./TestComponent.vue?vue&type=script&lang=js"
export * from "./TestComponent.vue?vue&type=script&lang=js"

import "./TestComponent.vue?vue&type=style&index=0&id=54c2bb2e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__